import React, { useEffect, useState } from "react";
import "./file-upload.css";

import {
  Box,
  Typography,
  Button,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import UploadIcon from "@mui/icons-material/FileUploadOutlined";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import { signOut } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import { auth } from "../../auth/firebase-config";
import { Flex } from "../flex";
import { UseSnackbar } from "../snackbar/snackbarContext";
import Dashboard_table from "../dashboard/dashboard_table";

const uploadConfigs = {
  "Generate Feature Needs with Rationale": [
    {
      id: "description_file",
      heading: "Description Document*",
      multiple: false,
      mandatory: true,
      section: "Needs",
    },
    {
      id: "additional_files",
      heading: "Additional Documents",
      multiple: true,
      mandatory: false,
      section: "Needs",
    },
  ],
  "Generate Use cases": [
    {
      id: "needs_file",
      heading: "Feature Needs Document* ",
      multiple: false,
      mandatory: true,
      section: "Usecases",
    },
    {
      id: "wireframe_file",
      heading: "Wireframes Document",
      multiple: false,
      mandatory: false,
      section: "Usecases",
    },
    {
      id: "additional_files",
      heading: "Additional Documents",
      multiple: true,
      mandatory: false,
      section: "Usecases",
    },
  ],
  "Generate Feature Requirements with Rationale": [
    {
      id: "needs_file",
      heading: "Feature Needs Document* ",
      multiple: false,
      mandatory: true,
      section: "Requirements",
    },
    {
      id: "usecase_file",
      heading: "Usecase Document* ",
      multiple: false,
      mandatory: true,
      section: "Requirements",
    },
    {
      id: "additional_files",
      heading: "Additional Documents",
      multiple: true,
      mandatory: false,
      section: "Requirements",
    },
  ],
  "Generate User Stories": [
    {
      id: "requirements_file",
      heading: "Feature Requirements* ",
      multiple: false,
      mandatory: true,
      section: "User_stories",
    },
    {
      id: "wireframe_file",
      heading: "Wireframe",
      multiple: false,
      mandatory: false,
      section: "User_stories",
    },
    {
      id: "additional_files",
      heading: "Additional Documents",
      multiple: true,
      mandatory: false,
      section: "User_stories",
    },
  ],
  "Generate Test Case Steps": [
    {
      id: "requirements_file",
      heading: "Feature Requirements* ",
      multiple: false,
      mandatory: true,
      section: "test_case_steps",
    },
    {
      id: "user_stories_file",
      heading: "User Stories* ",
      multiple: false,
      mandatory: true,
      section: "test_case_steps",
    },
    {
      id: "additional_files",
      heading: "Additional Documents",
      multiple: true,
      mandatory: false,
      section: "test_case_steps",
    },
  ],
  "Generate Acceptance Criteria & Expected Results": [
    {
      id: "requirements_file",
      heading: "Feature Requirements* ",
      multiple: false,
      mandatory: true,
      section: "Expected_results",
    },
    {
      id: "user_stories_file",
      heading: "User Stories* ",
      multiple: false,
      mandatory: true,
      section: "Expected_results",
    },
    {
      id: "testcases_file",
      heading: "Test Case Steps* ",
      multiple: false,
      mandatory: true,
      section: "Expected_results",
    },
    {
      id: "additional_files",
      heading: "Additional Documents",
      multiple: true,
      mandatory: false,
      section: "Expected_results",
    },
  ],
  "Generate Parent": [
    {
      id: "requirements",
      heading: "Feature Requirements* ",
      multiple: false,
      mandatory: true,
      section: "parent_generation",
    },
  ],
  "End to End Traceability": [
    {
      id: "needs_file",
      heading: "Feature Needs Document* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
    {
      id: "usecases_file",
      heading: "Usecase Document* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
    {
      id: "requirements_file",
      heading: "Feature Requirements* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
    {
      id: "userstories_file",
      heading: "User Stories* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
    {
      id: "testcases_file",
      heading: "Test Cases* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
    {
      id: "expectedresults_file",
      heading: "Expected Results* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
    {
      id: "srs_file",
      heading: "System Requirements* ",
      multiple: false,
      mandatory: true,
      section: "Traceability",
    },
  ],
};

const mandatorydoc = {
  "Generate Feature Needs with Rationale": ["description_file"],
  "Generate Use cases": ["needs_file"],
  "Generate Feature Requirements with Rationale": [
    "needs_file",
    "usecase_file",
  ],
  "Generate User Stories": ["requirements_file"],
  "Generate Test Case Steps": ["requirements_file", "user_stories_file"],
  "Generate Acceptance Criteria & Expected Results": [
    "requirements_file",
    "user_stories_file",
    "testcases_file",
  ],
  "Generate Parent": ["requirements"],
  "End to End Traceability": [
    "needs_file",
    "usecases_file",
    "requirements_file",
    "userstories_file",
    "testcases_file",
    "expectedresults_file",
    "srs_file",
  ],
};

function UploadBox({
  docType,
  products,
  savedProducts,
  loading,
  setload,
  editUpload,
  document_data,
  conversation_id,
  document_id,
  document_project_type,
  setdocument_data,
  userdisabled,
}: any) {
  const navigate = useNavigate();

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const value = queryParams.get("project_name");

  const [userediting, setuserediting] = useState(false);
  const [projectType, setproject] = useState("");
  const showSnackbar = UseSnackbar();
  const [selectedFile, setSelectedFile] = useState([]);
  const [open, setOpen] = useState(false);
  const [tableopen, settableopen] = useState(false);
  const [dragging, setDragging] = useState(false);
  const requiredFiles = mandatorydoc[docType];

  const filetypes = [
    "application/pdf",
    "text/plain",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const filetypes_add = [
    "application/pdf",
    "text/plain",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const filetypes_e2e = [
    "application/pdf",
    "text/plain",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
    "& .MuiDialog-paper": {
      padding: "1.5rem",
    },
  }));
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClose1 = () => {
    settableopen(false);
  };
  const handledialog = async () => {
    setOpen(false);
    setload(true);
    const accessToken = localStorage.getItem("accessToken");
    const userInfo = JSON.parse(localStorage.getItem("user_data"));
    const uuid = userInfo.id;
    const API_URL = `${import.meta.env.VITE_API_URL}/source-upload`;
    uploadDocuments(API_URL, accessToken, uuid);
  };

  async function transformResponse(response) {
    const attachments = {
      additional_files: [],
    };
    const source_ids = [];
    const userInfo = JSON.parse(localStorage.getItem("user_data"));
    const uuid = userInfo.id;
    if (response.data) {
      for (const item of response.data) {
        const sourceType = item.data.source_type;
        const docUrl = item.data.doc_url;
        const sourceId = item.data.id;

        if (sourceType === "additional_files") {
          attachments.additional_files.push(docUrl);
        } else {
          attachments[sourceType] = docUrl;
        }

        source_ids.push(sourceId);
      }
    }

    if (document_data) {
      const documentData = document_data;

      for (const key of Object.keys(documentData)) {
        if (key !== "additional_files") {
          const fileEntry = documentData[key];

          if (fileEntry && typeof fileEntry === "object") {
            if (fileEntry.doc_url) {
              attachments[key] = fileEntry.doc_url;
            }

            if (fileEntry.source_generated) {
              if (fileEntry.id) {
                source_ids.push(fileEntry.id);
              }
            } else {
              const payload = {
                doc_url: fileEntry.doc_url,
                is_generated: false,
                project_name: "",
                source_type: key,
                title: "Title",
                user_id: uuid,
              };

              try {
                const responseData = await postSourceData(payload);
                if (responseData && responseData.data && responseData.data.id) {
                  source_ids.push(responseData.data.id);
                }
              } catch (err) {
                console.error("Error posting source data:", err);
              }
            }
          }
        }
      }

      if (
        documentData.additional_files &&
        Array.isArray(documentData.additional_files)
      ) {
        for (const fileEntry of documentData.additional_files) {
          if (fileEntry && typeof fileEntry === "object" && fileEntry.doc_url) {
            attachments.additional_files.push(fileEntry.doc_url);
            if (fileEntry.id) {
              source_ids.push(fileEntry.id);
            }
          }
        }
      }
    }

    const projectname = projectType || document_project_type;
    return {
      project_name: projectname,
      attachments: attachments,
      conversation_id: "",
      display_message: false,
      message: "",
      user_id: uuid,
      section: uploadConfigs[docType][0].section,
      source_ids: source_ids,
      process: "init",
      version_uri: "",
      product: products,
    };
  }

  async function uploadDocuments(API_URL, accessToken, uuid) {
    if (result.files.length > 0) {
      const formData = new FormData();
      formData.append("project_name", projectType);
      formData.append("user_id", uuid);
      formData.append("doc_type", uploadConfigs[docType][0].section);
      result.files.forEach((fileObj) => {
        const file = fileObj.file;
        formData.append(`files`, file);
        formData.append(`file_types`, fileObj.file_type);
      });

      try {
        const response = await axios.post(API_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (response.data && response.data.data) {
          try {
            const transformedResponse = await transformResponse(response.data);
            showSnackbar(
              "Documents uploaded successfully and generating response",
              "success"
            );
            setSelectedFile([]);
            setload(false);
            navigate("/chatpage", { state: { transformedResponse } });
          } catch (error) {
            if (error.response && error.response.status === 401) {
              signOut(auth)
                .then(() => {
                  localStorage.removeItem("userInfo");
                  localStorage.removeItem("accessToken");
                  localStorage.removeItem("user_data");
                  console.log("User signed out due to inactivity.");
                })
                .catch((signOutError) => {
                  console.error("Error signing out:", signOutError);
                });
            } else {
              console.error("Error transforming response:", error);
              showSnackbar(
                "Failed to upload documents. Please try again.",
                "error"
              );
              throw new Error(`Internal server error: ${error}`);
            }
          }
        } else {
          throw new Error("Invalid response format");
        }
        return response;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          signOut(auth)
            .then(() => {
              localStorage.removeItem("userInfo");
              localStorage.removeItem("accessToken");
              localStorage.removeItem("user_data");
              console.log("User signed out due to inactivity.");
            })
            .catch((signOutError) => {
              console.error("Error signing out:", signOutError);
            });
        } else {
          showSnackbar("Internal Server Error! Please try Again!", "error");
          throw new Error(`Internal server error: ${error}`);
        }
        setSelectedFile([]);
      } finally {
        setload(false);
      }
    } else {
      const response = {};
      const transformedResponse = await transformResponse(response);
      showSnackbar(
        "Documents uploaded successfully and generating response",
        "success"
      );
      setSelectedFile([]);
      setload(false);
      navigate("/chatpage", { state: { transformedResponse } });
    }
  }

  const postSourceData = async (payload) => {
    const accessToken = localStorage.getItem("accessToken");
    const API_URL = `${import.meta.env.VITE_API_URL}/Source`;

    try {
      const response = await axios.post(API_URL, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        signOut(auth)
          .then(() => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("user_data");
            console.log("User signed out due to inactivity.");
          })
          .catch((signOutError) => {
            console.error("Error signing out:", signOutError);
          });
      } else {
        showSnackbar("Something Went Wrong! Please Try again! ", "error");
        throw new Error(`Internal server error: ${error}`);
      }
    }
  };

  const handleFileChange = (event, buttonId, multiple) => {
    if (document_data) {
      setuserediting(true);
    }
    const selectedFiles = Array.from(event.target.files);
    handlefiles(selectedFiles, buttonId, multiple);
  };

  const handlefiles = (selectedFiles, buttonId, multiple) => {
    const MAX_FILE_SIZE = 10000000;
    const MAX_TOTAL_FILES = 5;

    if (
      docType === "End to End Traceability" &&
      buttonId === "expectedresults_file"
    ) {
      for (const file of selectedFiles) {
        if (!filetypes_e2e.includes(file.type)) {
          showSnackbar("File Type not allowed.", "error");
          return;
        }
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (fileExtension === "text") {
          showSnackbar("File Type not allowed.", "error");
          return;
        }
      }
    } else if (
      buttonId === "additional_files" ||
      buttonId === "wireframe_file"
    ) {
      for (const file of selectedFiles) {
        if (!filetypes_add.includes(file.type)) {
          showSnackbar("File Type not allowed.", "error");
          return;
        }
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (fileExtension === "text") {
          showSnackbar("File Type not allowed.", "error");
          return;
        }
      }
    } else {
      for (const file of selectedFiles) {
        if (!filetypes.includes(file.type)) {
          showSnackbar("File Type not allowed.", "error");
          return;
        }
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (fileExtension === "text") {
          showSnackbar("File Type not allowed.", "error");
          return;
        }
      }
    }

    for (const file of selectedFiles) {
      if (file.size > MAX_FILE_SIZE) {
        showSnackbar("File Size limit is 10MB.", "error");
        return;
      }
    }

    const currentFiles = selectedFile[buttonId] || [];
    const currentFilesCount = currentFiles.length;

    const documentAdditionalFilesCount =
      document_data?.additional_files?.length || 0;

    const remainingSlots =
      MAX_TOTAL_FILES - (documentAdditionalFilesCount + currentFilesCount);

    if (multiple) {
      if (selectedFiles.length > remainingSlots) {
        showSnackbar(
          `You can only upload up to ${remainingSlots} more files.`,
          "error"
        );
        return;
      }
    } else {
      if (selectedFiles.length > 1) {
        showSnackbar("Only 1 file can be uploaded at a time!", "error");
        return;
      }

      if (remainingSlots < 1) {
        showSnackbar("You have reached the maximum file limit!", "error");
        return;
      }
    }

    setSelectedFile((prevFiles: any) => ({
      ...prevFiles,
      [buttonId]: multiple
        ? [...(prevFiles[buttonId] || []), ...selectedFiles]
        : selectedFiles,
    }));
  };

  const removeFile = (buttonId, fileIndex) => {
    setSelectedFile((prevFiles) => {
      const updatedFiles = prevFiles[buttonId].filter(
        (_, index) => index !== fileIndex
      );
      return {
        ...prevFiles,
        [buttonId]: updatedFiles,
      };
    });
  };

  const areMandatoryFilesUploaded = requiredFiles?.every((id) => {
    const fileInSelected = selectedFile[id];
    const isFileInSelectedValid = fileInSelected && fileInSelected.length > 0;

    const fileInDocumentData = document_data?.[id];
    let isFileInDocumentDataValid = false;
    if (Array.isArray(fileInDocumentData)) {
      isFileInDocumentDataValid = fileInDocumentData.length > 0;
    } else if (fileInDocumentData && fileInDocumentData.doc_url) {
      isFileInDocumentDataValid = true;
    }

    return isFileInSelectedValid || isFileInDocumentDataValid;
  });

  useEffect(() => {
    setSelectedFile([]);
  }, [docType, setSelectedFile]);

  useEffect(() => {
    setproject(value);
  }, []);

  const handleDragOver = (event) => {
    if (docType) {
      event.preventDefault();
      setDragging(true);
    }
  };

  useEffect(() => {
    if (savedProducts?.length !== products?.length) {
      setuserediting(true);
      return;
    }

    const savedProductsStrings = savedProducts
      ?.map((product: any) => JSON.stringify(product))
      .sort();
    const productsStrings = products
      ?.map((product: any) => JSON.stringify(product))
      .sort();

    const hasChanged = productsStrings?.some((productStr: any, index: any) => {
      return productStr !== savedProductsStrings[index];
    });

    if (hasChanged) {
      setuserediting(true);
    } else {
      setuserediting(false);
    }
  }, [products, savedProducts]);

  const result = {
    files: Object.keys(selectedFile).flatMap((key) =>
      selectedFile[key].map((file) => ({
        file: file,
        file_type: key,
      }))
    ),
  };

  const handleDragLeave = () => {
    if (docType) setDragging(false);
  };
  const handleDrop = (event, id, multiple) => {
    const dropDisabled =
      (document_data && document_data[id] && id !== "additional_files") ||
      (id === "additional_files" && totalAdditionalFilesCount === 5);
    if (dropDisabled) {
      showSnackbar("File cannot to uploaded", "error");
      event.preventDefault();
      return;
    }
    event.preventDefault();
    const selectedFiles = Array.from(event.dataTransfer.files);
    handlefiles(selectedFiles, id, multiple);
    setDragging(false);
  };

  const formatFileName = (name) => {
    if (name.length > 20) {
      return `${name.slice(0, 16)}...${name.slice(-5)}`;
    }
    return name;
  };

  const handlechatpage = () => {
    const userInfo = JSON.parse(localStorage.getItem("user_data"));
    const uuid = userInfo.id;
    if (docType === "End to End Traceability") {
      const attachments = {
        additional_files: [],
      };
      const source_ids = [];
      if (document_data) {
        const documentData = document_data;
        Object.keys(documentData).forEach((key) => {
          if (key !== "additional_files") {
            const fileEntry = documentData[key];
            if (fileEntry && typeof fileEntry === "object") {
              if (fileEntry.doc_url) {
                attachments[key] = fileEntry.doc_url;
              }
              if (fileEntry.id) {
                source_ids.push(fileEntry.id);
              }
            }
          } else if (
            key === "additional_files" &&
            Array.isArray(documentData[key])
          ) {
            documentData[key].forEach((fileEntry) => {
              if (
                fileEntry &&
                typeof fileEntry === "object" &&
                fileEntry.doc_url
              ) {
                attachments.additional_files.push(fileEntry.doc_url);
                if (fileEntry.id) {
                  source_ids.push(fileEntry.id);
                }
              }
            });
          }
        });
      }
      const transformedResponse = {
        attachments: attachments,
        project_name: document_project_type,
        document_id: document_id,
        conversation_id: conversation_id,
        user_id: uuid,
        section: uploadConfigs[docType][0].section,
        user_disabled: userdisabled,
        source_ids: source_ids,
        product: products,
      };
      navigate("/chatpage", { state: { transformedResponse } });
    } else {
      const transformedResponse = {
        project_name: document_project_type,
        document_id: document_id,
        conversation_id: conversation_id,
        user_id: uuid,
        section: uploadConfigs[docType][0].section,
        user_disabled: userdisabled,
        product: products,
      };

      if (transformedResponse.section === "parent_generation") {
        navigate("/generateparent", { state: { transformedResponse } });
      } else {
        navigate("/chatpage", { state: { transformedResponse } });
      }
    }
  };

  const removeFile_document_data = (id, index) => {
    setuserediting(true);
    if (Array.isArray(document_data[id])) {
      const updatedFiles = document_data[id].filter((_, i) => i !== index);

      setdocument_data((prevData) => ({
        ...prevData,
        [id]: updatedFiles,
      }));
    } else {
      const { [id]: _, ...remainingData } = document_data;
      setdocument_data(remainingData);
    }
  };

  const documentAdditionalFilesCount =
    document_data?.additional_files?.length || 0;
  const selectedAdditionalFilesCount =
    selectedFile?.additional_files?.length || 0;

  const totalAdditionalFilesCount =
    documentAdditionalFilesCount + selectedAdditionalFilesCount;

  const uniqueSectionParentPairs = [
    { section: "needs_file", parentLabel: "Feature Needs with Rationale" },
    { section: "usecase_file", parentLabel: "Use cases" },
    {
      section: "requirements_file",
      parentLabel: "Feature Requirements with Rationale",
    },
    { section: "user_stories_file", parentLabel: "User Stories" },
    { section: "testcases_file", parentLabel: "Test Case Steps" },
    {
      section: "expectedresults_file",
      parentLabel: "Acceptance Criteria & Expected Results",
    },
    { section: "requirements_file", parentLabel: "System Requirements" },
  ];
  const uniqueSectionParentPairs2 = [
    {
      section: "requirements",
      parentLabel: "Feature Requirements with Rationale",
    },
  ];
  const uniqueSectionParentPairs1 = [
    { section: "needs_file", parentLabel: "Feature Needs with Rationale" },
    {
      section: "requirements_file",
      parentLabel: "Feature Requirements with Rationale",
    },
    { section: "usecases_file", parentLabel: "Use cases" },
    { section: "userstories_file", parentLabel: "User Stories" },
    { section: "testcases_file", parentLabel: "Test Case Steps" },
    {
      section: "expectedresults_file",
      parentLabel: "Acceptance Criteria & Expected Results",
    },
    { section: "srs_file", parentLabel: "System Requirements" },
  ];

  const [selectedId, setSelectedId] = useState(null);
  const handletabledialog = (id) => {
    if (docType === "Generate Parent") {
      const matchedSection = uniqueSectionParentPairs2.find(
        (pair) => pair.section === id
      );
      console.log(id, "++", matchedSection);
      setSelectedId(matchedSection.parentLabel);
      settableopen(true);
    } else if (docType === "End to End Traceability") {
      const matchedSection = uniqueSectionParentPairs1.find(
        (pair) => pair.section === id
      );
      console.log(id, "++", matchedSection);
      setSelectedId(matchedSection.parentLabel);
      settableopen(true);
    } else {
      const matchedSection = uniqueSectionParentPairs.find(
        (pair) => pair.section === id
      );
      console.log(id, "++", matchedSection);
      setSelectedId(matchedSection.parentLabel);
      settableopen(true);
    }
  };

  const handleSelectDocument = (data) => {
    if (docType === "Generate Parent") {
      const matchedSection = uniqueSectionParentPairs2.find(
        (pair) => pair.parentLabel === data.doctype
      );
      setdocument_data((prevData) => ({
        ...prevData,
        [matchedSection.section]: {
          id: data.document_id,
          doc_url: data.gcs_url,
          source_generated: false,
        },
      }));
      settableopen(false);
    } else if (docType === "End to End Traceability") {
      const matchedSection = uniqueSectionParentPairs1.find(
        (pair) => pair.parentLabel === data.doctype
      );
      setdocument_data((prevData) => ({
        ...prevData,
        [matchedSection.section]: {
          id: data.document_id,
          doc_url: data.gcs_url,
          source_generated: false,
        },
      }));
      settableopen(false);
    } else {
      let docType = data?.doctype;
      if (docType === "Feature needs with Rationale") {
        docType = "Feature Needs with Rationale";
      }
      const matchedSection = uniqueSectionParentPairs.find(
        (pair) => pair.parentLabel === docType
      );
      setdocument_data((prevData: any) => ({
        ...prevData,
        [matchedSection.section]: {
          id: data.document_id,
          doc_url: data.gcs_url,
          source_generated: false,
        },
      }));
      settableopen(false);
    }
  };

  return (
    <div>
      <Box
        className={"upload-box"}
        sx={{
          ...(userdisabled && {
            opacity: 0.5,
            pointerEvents: "none",
          }),
        }}
      >
        {uploadConfigs[docType]?.map(({ id, heading, multiple, mandatory }) => (
          <Box key={id}>
            <Box
              className={"small-box"}
              component="label"
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={(event) => handleDrop(event, id, multiple)}
            >
              <Typography
                variant="h6"
                sx={{ fontSize: "1rem", fontWeight: "bold" }}
              >
                {heading}
              </Typography>
              {mandatory && (
                <Typography
                  variant="h6"
                  sx={{ fontSize: "0.8rem", fontWeight: "bold", color: "red" }}
                >
                  (Required)
                </Typography>
              )}
              {docType === "End to End Traceability" &&
                id === "expectedresults_file" && (
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      color: "green",
                    }}
                  >
                    (.xlxs also supported)
                  </Typography>
                )}
              {id === "wireframe_file" && (
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  (images also supported)
                </Typography>
              )}
              {id === "additional_files" && (
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  (images also supported)
                </Typography>
              )}
              <VisuallyHiddenInput
                disabled={
                  (document_data &&
                    document_data[id] &&
                    id !== "additional_files") ||
                  (id === "additional_files" && totalAdditionalFilesCount === 5)
                }
                type="file"
                accept={filetypes}
                multiple={multiple}
                value={""}
                onChange={(event) => handleFileChange(event, id, multiple)}
                required={requiredFiles.includes({ id })}
              />
              <UploadIcon fontSize="medium" />
              <Typography sx={{ fontSize: "1rem" }}>
                Click to{" "}
                <span className="browse-text" sx={{ fontSize: "1rem" }}>
                  browse
                </span>{" "}
                or
              </Typography>
              <Typography sx={{ fontSize: "1rem" }}>
                drag and drop your files
              </Typography>
            </Box>
            <Box>
              <Flex
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5rem",
                }}
              >
                {editUpload && document_data[id] ? (
                  Array.isArray(document_data[id]) ? (
                    <>
                      {document_data[id].map((fileUrl, index) => (
                        <Typography
                          key={`document-${index}`}
                          sx={{
                            color: "green",
                            padding: "0",
                            fontSize: "1rem",
                            marginBottom: "2.25rem"
                          }}
                        >
                          {formatFileName(fileUrl.doc_url.split("/").pop())}
                          <IconButton
                            aria-label="delete"
                            sx={{ fontSize: "1rem", m: 0 }}
                            onClick={() => removeFile_document_data(id, index)}
                            disabled={loading}
                          >
                            <DeleteIcon fontSize="inherit" />
                          </IconButton>
                        </Typography>
                      ))}
                      {selectedFile[id] &&
                        selectedFile[id].map((file, index) => (
                          <Typography
                            key={`selected-${index}`}
                            className="filename-txt"
                            sx={{
                              color: "green",
                              padding: "0",
                              fontSize: "1rem",
                            }}
                          >
                            {formatFileName(file.name)}
                            <IconButton
                              aria-label="delete"
                              sx={{ fontSize: "1rem", m: 0 }}
                              onClick={() => removeFile(id, index)}
                              disabled={loading}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </Typography>
                        ))}
                    </>
                  ) : (
                    <>
                      <Typography
                        sx={{ color: "green", padding: "0", fontSize: "1rem",
                          marginBottom: "2.25rem",
                         }}
                      >
                        {formatFileName(
                          document_data[id].doc_url.split("/").pop()
                        )}
                        <IconButton
                          aria-label="delete"
                          sx={{ fontSize: "1rem", m: 0 }}
                          onClick={() => removeFile_document_data(id, null)}
                          disabled={loading}
                        >
                          <DeleteIcon fontSize="inherit" />
                        </IconButton>
                      </Typography>
                      {selectedFile[id] &&
                        selectedFile[id].map((file, index) => (
                          <Typography
                            key={`selected-${index}`}
                            className="filename-txt"
                            sx={{
                              color: "green",
                              padding: "0",
                              fontSize: "1rem",
                            }}
                          >
                            {formatFileName(file.name)}
                            <IconButton
                              aria-label="delete"
                              sx={{ fontSize: "1rem", m: 0 }}
                              onClick={() => removeFile(id, index)}
                              disabled={loading}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </Typography>
                        ))}
                    </>
                  )
                ) : document_data[id] ? (
                  <>
                    {Array.isArray(document_data[id]) ? (
                      document_data[id].map((fileUrl, index) => (
                        <>
                          <Typography
                            key={`document-${index}`}
                            sx={{
                              color: "green",
                              padding: "0",
                              fontSize: "1rem",
                              marginBottom: "2.25rem"
                            }}
                          >
                            {formatFileName(fileUrl.doc_url.split("/").pop())}
                            <IconButton
                              aria-label="delete"
                              sx={{ fontSize: "1rem", m: 0 }}
                              onClick={() => removeFile_document_data(id, null)}
                              disabled={loading}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </Typography>
                        </>
                      ))
                    ) : (
                      <>
                        <Typography
                          sx={{
                            color: "green",
                            padding: "0",
                            fontSize: "1rem",
                            marginBottom: "2.25rem"
                          }}
                        >
                          {formatFileName(
                            document_data[id].doc_url.split("/").pop()
                          )}
                          <IconButton
                            aria-label="delete"
                            sx={{ fontSize: "1rem", m: 0 }}
                            onClick={() => removeFile_document_data(id, null)}
                            disabled={loading}
                          >
                            <DeleteIcon fontSize="inherit" />
                          </IconButton>
                        </Typography>
                      </>
                    )}
                    {selectedFile[id] &&
                      selectedFile[id].map((file, index) => (
                        <Typography
                          key={`selected-${index}`}
                          className="filename-txt"
                          sx={{
                            color: "green",
                            padding: "0",
                            fontSize: "1rem",
                          }}
                        >
                          {formatFileName(file.name)}
                        </Typography>
                      ))}
                  </>
                ) : // When editUpload is false or document_data[id] is not available
                selectedFile[id] && selectedFile[id].length > 0 ? (
                  // If files are selected
                  selectedFile[id].map((file, index) => (
                    <Typography
                      key={index}
                      className="filename-txt"
                      sx={{ color: "green", padding: "0", fontSize: "1rem" }}
                    >
                      {formatFileName(file.name)}
                      <IconButton
                        aria-label="delete"
                        sx={{ fontSize: "1rem", m: 0 }}
                        onClick={() => removeFile(id, index)}
                        disabled={loading}
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </Typography>
                  ))
                ) : (
                  <>
                    <Typography
                      sx={{
                        mt: 0.5,
                        color: "red",
                        padding: "0",
                        fontSize: "1rem",
                      }}
                    >
                      No file selected
                    </Typography>
                    {mandatory &&
                      id !== "description_file" &&
                      !(
                        docType === "End to End Traceability" &&
                        id === "expectedresults_file"
                      ) ? (
                        <Button
                          variant="contained"
                          onClick={() => handletabledialog(id)}
                          sx={{
                            textTransform: "capitalize",
                            fontSize: "0.8rem",
                            padding: "0.4rem",
                          }}
                        >
                          Select Dashboard files
                        </Button>
                      ) : (
                        <div className="mb-9"></div>
                      )}
                  </>
                )}
              </Flex>
            </Box>
          </Box>
        ))}
      </Box>
      <Flex>
        {(!editUpload || userediting) && (
          <Button
            type="submit"
            className="generate-button"
            disabled={!areMandatoryFilesUploaded || loading}
            variant="contained"
            sx={{ mt: 2, textTransform: "capitalize", fontSize: "20px" }}
            onClick={handleClickOpen}
          >
            Upload
          </Button>
        )}
        {editUpload && !userediting && (
          <Button
            type="submit"
            className="generate-button"
            disabled={loading}
            variant="contained"
            sx={{ mt: 2, textTransform: "capitalize", fontSize: "20px" }}
            onClick={handlechatpage}
          >
            Go to Chat
          </Button>
        )}
      </Flex>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={tableopen}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{}} id="customized-dialog-title">
          <IconButton
            aria-label="close"
            onClick={handleClose1}
            sx={{
              position: "absolute",
              right: 8,
              top: 1,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="h3">
              This table contain files from the Dashboard table of :
              <strong> {selectedId}&nbsp;</strong>
              for upload.
            </Typography>
          </DialogContentText>
          <Dashboard_table
            selectedId={selectedId}
            handleSelectDocument={handleSelectDocument}
          />
        </DialogContent>
      </Dialog>
      <BootstrapDialog
        className="dialogbox"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{ padding: "5rem" }}
      >
        <DialogTitle sx={{}} id="customized-dialog-title">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 1,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Typography variant="normal" sx={{ m: 1.5, fontSize: "1.5rem" }}>
          Did you upload the relevant documents?
          {[
            "Generate Feature Needs with Rationale",
            "Generate Feature Needs with Rationale",
            "Generate Use cases",
            "Generate Feature Requirements with Rationale",
          ].includes(docType) && (
            <p className="text-red-600">
              Disclaimer: Product selection is essential
            </p>
          )}
        </Typography>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handledialog}
            sx={{ textTransform: "capitalize", fontSize: "1rem" }}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ textTransform: "capitalize", fontSize: "1rem" }}
          >
            No
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export default UploadBox;
